import {
  AppShowcase,
  BlogHighlights,
  CannectCuidaSection,
  CommonQuestionsSection,
  DiscoverySection,
  HeroSection,
  HowItWorksSection,
  NextStepCTA,
  PatientReviews,
  PillPharmacySection,
  TrustSection
} from '@cannect/new-components/organisms'
import SEO from 'components/SEO'
import { useHome } from './useHome'

/**
 * Home do Novo Marketplace (Figma node 4333:296).
 *
 * Todas as seções são full-bleed e trazem o próprio container de 1166px, na ordem do protótipo.
 * As seções da home anterior (HealthcareIntro, PrescriptionBanner, CareStepsBanner, o carrossel
 * "Coordenando o cuidado", "Médicos parceiros", "Marcas selecionadas", CareFormBanner e a barra
 * flutuante StickyFooterCTA) não existem no protótipo novo e foram removidas.
 */
export const HomeUI = ({ postsList }: ReturnType<typeof useHome>) => {
  const handleGoToAndroidStore = () => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        allow_custom_scripts: true,
        send_to: 'DC-15596039/invmedia/canne0000+standard'
      })
    }

    window.open('https://bit.ly/app-cannect-android', '_blank')
  }

  const handleGoToIOSStore = () => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        allow_custom_scripts: true,
        send_to: 'DC-15596039/invmedia/canne00000+standard'
      })
    }

    window.open('https://bit.ly/app-cannect-ios', '_blank')
  }

  return (
    <div className="w-full bg-gray-50">
      <SEO
        title="Cannabis Medicinal, Saúde e Bem-estar"
        description="A Cannect simplifica o acesso à Cannabis Medicinal no Brasil, conectando pacientes a médicos especializados, produtos regulamentados e acompanhamento contínuo."
        canonical="/"
        keywords="cannabis medicinal, CBD, THC, CBN, consulta médica, canabidiol, tratamento cannabis, médico cannabis, receita cannabis, autorização ANVISA"
      />

      <HeroSection />

      <HowItWorksSection />

      <DiscoverySection />

      <TrustSection />

      <PillPharmacySection />

      <CannectCuidaSection />

      <PatientReviews />

      <AppShowcase onAndroidClick={handleGoToAndroidStore} onIOSClick={handleGoToIOSStore} />

      <BlogHighlights posts={postsList} />

      <CommonQuestionsSection />

      <NextStepCTA />
    </div>
  )
}
